module.exports = __webpack_public_path__ + "img/edit-active.8a453bc0.svg";